// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"roX4Hetp","rightWrapper":"lPfAAFFQ","titleLabel":"XjDobik_","categoryLabel":"RkJYMDEs"};